// extracted by mini-css-extract-plugin
export default {"dialog":"dialog_dialog__KXR7Z","title":"dialog_title__mj1Tg","message":"dialog_message__DjuEU"};